import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { Input } from 'src/common/components/input';
import { useIsFullscreen } from 'src/services/desktop';
import { isMacElectron } from 'src/utils/electron';
import { GlobalSearchType, useOpenSearchPopup } from '../../header/search';
import { TocCollapseButton } from '../toc-trigger';
import { useShareAsideRootId } from './share-aside-context';

interface Props {}
export const ShareAsideHeader: FC<Props> = () => {
  const openSearchPopup = useOpenSearchPopup();
  const rootId = useShareAsideRootId();
  const isFullscreen = useIsFullscreen();
  const isDesktopMode = isMacElectron && !isFullscreen;

  return (
    <div
      className={cx(
        'relative flex items-center pt-3 mx-2.5 justify-between',
        isDesktopMode && 'pt-12'
      )}
    >
      <div
        className="w-[calc(100%-24px)] cursor-pointer relative"
        onClick={() => {
          openSearchPopup({
            rootPageId: rootId,
            inPageId: rootId,
            type: GlobalSearchType.share,
          });
        }}
      >
        <Icon
          size="normal"
          className="absolute left-2.5 top-1.5 text-xl text-grey4 leading-none pointer-events-none z-10"
          name="IcSearch"
        />
        <Input
          readonly={true}
          className="h-8 pl-10 rounded-sm hover:animate-hover pointer-events-none"
          inputClassName="pl-0"
          placeholder="搜索标题/内容"
        />
      </div>

      <TocCollapseButton />
    </div>
  );
};
